import { isCheckedCheckboxCustomFieldValue } from '@webapp/core/utils/customfields'
import { useProcurifyIntl } from '@webapp/hooks'
import { useFormatBudgetCustomFieldName } from '@webapp/platform/budgets'
import { type IBudgetCategoryAttributeDescription } from '../BudgetCategoryAttributeDescriptions'
import messages from '../messages'

export interface IBudgetCustomFieldAttributeInput {
  name: string
  isActive: boolean
  isCheckbox: boolean
  values: string[]
}

export const useFormatBudgetCustomFieldAttribute = () => {
  const intl = useProcurifyIntl()
  const formatBudgetCustomFieldName = useFormatBudgetCustomFieldName()

  const formatValue = (isCheckbox: boolean, value: string) => {
    if (!isCheckbox) return value

    return intl.formatMessage(
      isCheckedCheckboxCustomFieldValue(value)
        ? messages.yesText
        : messages.noText
    )
  }

  return ({
    name,
    isActive,
    isCheckbox,
    values,
  }: IBudgetCustomFieldAttributeInput): IBudgetCategoryAttributeDescription => ({
    label: formatBudgetCustomFieldName(name, isActive),
    value: values.map((value) => formatValue(isCheckbox, value)),
  })
}
